import { useForm, UseFormProps, FormProvider } from 'react-hook-form';
import FormSetCoinsToUserFooter from './FormSetCoinsToUserFooter';
import FormSetCoinsToUserHeader from './FormSetCoinsToUserHeader';
import FormSetCoinsToUserBody from './FormSetCoinsToUserBody';
import { AdminUserPermissionsEnum } from '@/lib/enum';
import { DEFAULT_FORM_CONFIG } from '@/constants';
import { useUserConnected } from '@/hooks';
import { TCallbackForm } from '@/types';
import { MainTabEnum } from './mainTab.enum';
import { TFormData, TUser } from '.';

type TProps = {
  disableInvalidateQueries?: boolean;
  callback?: TCallbackForm<TFormData>;
  user: TUser;
};

const VARIABLES = {
  formConfig: DEFAULT_FORM_CONFIG as UseFormProps<TFormData>
};

const FormSetCoinsToUser = ({ callback, user, disableInvalidateQueries }: TProps) => {

  const { hasPermissions } = useUserConnected();

  const defaultMainTab: MainTabEnum = hasPermissions(AdminUserPermissionsEnum.ADD_REMOVE_USER_COINS)
    ? MainTabEnum.COINS
    : hasPermissions(AdminUserPermissionsEnum.ADD_REMOVE_USER_INCOGNITO)
      ? MainTabEnum.INCOGNITO
      : MainTabEnum.BOOST;

  const formMethods = useForm<TFormData>({
    ...VARIABLES.formConfig,
    values: {
      mainTab: defaultMainTab,
      user
    } as TFormData
  });

  return (
    <FormProvider {...formMethods}>
      <FormSetCoinsToUserHeader />
      <FormSetCoinsToUserBody />
      <FormSetCoinsToUserFooter
        disableInvalidateQueries={disableInvalidateQueries}
        callback={callback} />
    </FormProvider>
  );

};

export default FormSetCoinsToUser;
